import * as React from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import Graphs from './Graphs';
import AuthForms from './AuthForms';
import AccountForm from './AccountForm';
import Leaders from './leaders';
import Settings from './Settings';
import { wrap, withT } from '../../../lib/wrappers';
import s, { bindSelectors, pick } from '../../../redux/selectors';
import { State as ReduxState } from '../../../redux/types';

interface WidgetOptions {
  hideUserPlatform: boolean;
}

interface Props {
  t: (key: string) => string;
  isTokenValid: boolean;
  widgetOptions: WidgetOptions;
}
interface State {
  activeTab: number;
}

export class SidePage extends React.Component<Props, State> {
  public props: Props;

  constructor(props: Props, context: object) {
    super(props, context);
    this.state = {
      activeTab: 1
    };
  }

  public render() {
    const { t, isTokenValid, widgetOptions } = this.props;
    const { activeTab } = this.state;
    return (
      <div className="cc-component container container-md" id="side_page">
        <Tabs
          defaultActiveKey={1}
          id="side_page__tabs"
          activeKey={activeTab}
          onSelect={(key: any) => this.setState({ activeTab: key as number })}
        >
          <Tab eventKey={1} title={t('Your footprint')}>
            <Graphs active={this.state.activeTab === 1} />
          </Tab>
          {!widgetOptions.hideUserPlatform &&
            <Tab eventKey={2} title={t('Leaderboard')}>
              <Leaders />
            </Tab>
          }
          <Tab eventKey={3} title={t('Settings')}>
            <Settings />
          </Tab>
          {!widgetOptions.hideUserPlatform &&
            <Tab eventKey={4} title={isTokenValid ? t('Profile') : t('Login')}>
              {!isTokenValid && <AuthForms />}
              {isTokenValid && <AccountForm />}
            </Tab>
          }
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = (state: ReduxState, ownProps: Props) => bindSelectors(
  pick(s, ['isTokenValid', 'widgetOptions']), state, ownProps
);

export default wrap(
  withT('sidePage'),
  connect(mapStateToProps),
  SidePage
);
